
    /**
    * 置顶
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13300 {}
  /**
 * YResult :YResult
 */
export class IResid13300 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  export default (activityNo: any,  data?: IReqid13300): AxiosPromise<IResid13300> => request({
        method: 'POST',
        url: '/admin/activity/stickyActivity/'+activityNo,
        data: data
      })